import React from 'react';
import { classNames } from '../../libs/classNames';
import css from './WorkshopTagGroupCard.module.scss';
import EditCategoryIcon from '../../assets/images/edit.svg';
import DeleteCategoryIcon from '../../assets/images/delete.svg';
import AddBtn from '../../../components/ui/addBtn/AddBtn';
import { ModuleTag } from '../../../entities/module/private-template-module-tag/ui/module-tag';
import { ITagsGroup } from '../../../entities/template/private-template-tag-group/template-tag-group/api/types';

interface WorkshopTagGroupCardProps {
	className?: string,
	data?: ITagsGroup,
	onBindTag?: (groupId: string) => void,
	onUnbindTag?: (groupId: string, tagId: number) => void,
	onEditTagGroup?: (groupId: string) => void,
	onDeleteTagGroup?: (groupId: string) => void,
}

/**
 * Универсальный компонент карточки группы тегов.
 * Пример использования: модальное окно редактирования модулей, блок редактирования групп тегов.
 */
export const TagGroupCard = ({
	className,
	data,
	onDeleteTagGroup,
	onEditTagGroup,
	onUnbindTag,
	onBindTag,
}: WorkshopTagGroupCardProps) => {
	if (!data) {
		return null;
	}

	const { tags, name, id } = data;

	const onDelete = () => {
		onDeleteTagGroup?.(id);
	};

	const onEdit = () => {
		onEditTagGroup?.(id);
	};

	const onUnbind = (tagId: number) => {
		onUnbindTag?.(id, tagId);
	};

	const onBind = () => {
		onBindTag?.(id);
	};

	return (
		<div className={classNames(css.wrapper, {}, [className])}>
			<div className={css.main}>
				<div className={css.title}>
					<div className={css.text}>{name}</div>
					<div
						role="presentation"
						className={css.btn}
						onClick={onEdit}
					>
						<EditCategoryIcon />
					</div>
					<div
						role="presentation"
						className={css.btn}
						onClick={onDelete}
					>
						<DeleteCategoryIcon />
					</div>
				</div>
				<div className={css.tags}>
					{
						tags?.map((tag) => {
							const unbindTag = () => onUnbind?.(tag.id);

							return (
								<ModuleTag onUnbind={unbindTag} tag={tag} key={tag.id} />
							);
						})
					}
				</div>
			</div>
			<AddBtn btnText="Добавить тег в группу" onBtnClick={onBind} />
		</div>
	);
};
